import React from "react";
import classNames from "classnames";
import { cva } from "class-variance-authority";

const InputVariants = cva(
  /* button base style */
  `flex justify-center items-center font-poppins outline-none`,
  {
    variants: {
      /* button colors */
      intent: {
        primary:
          "bg-primary placehoder:text-base placeholder:font-normal placeholder:accent-grey-900",
        secondary:
          "bg-transparent border-2 border-accent-silver-300 text-accent-saurus placehoder:text-base placeholder:font-normal placeholder:text-accent-saurus",
        tertiary:
          "border-[1px] bg-transparent border-[#11111126] border-opacity-25 placeholder:text-base placeholder:font-normal text-accent-silver-900 placeholder:text-accent-silver-900",
        default:
          "bg-primary placehoder:text-base placeholder:font-normal placeholder:accent-grey-900",
      },

      /* button sizes */
      size: {
        sm: ["text-sm", "py-2", "px-2", "w-[450px]"],
        md: ["text-base", "py-2", "px-4"],
        lg: ["text-base", "py-3", "px-3"],
      },

      /* button roundness */
      roundness: {
        square: "rounded-none",
        "round-sm": "rounded-[8px]",
        "round-md": "rounded-lg",
        "round-lg": "rounded-3xl",
      },
    },

    // defaults
    defaultVariants: {
      intent: "default",
      size: "lg",
      roundness: "round-lg",
    },
  }
);

const Input = ({
  intent,
  type,
  size,
  roundness,
  eventAction,
  classes,
  placeholder,
  value,
  maxLimit,
  minLimit,
  name,
  selector,
  readOnly = false,
  isDisabled,
}) => {
  return (
    <input
      type={type}
      name={name}
      value={value}
      id={selector}
      placeholder={placeholder}
      onChange={eventAction}
      className={classNames(
        InputVariants({ intent, size, roundness }),
        classes
      )}
      disabled={isDisabled}
      maxLength={maxLimit}
      minLength={minLimit}
      readOnly={readOnly}
    />
  );
};

export default Input;
